import React from 'react';
import { Brodcrumb } from '../../components/ui/UtilsLayout';
import { iconsPath, imagePath, videoPath } from '../../utils/imagePath';
import { BackgroundWithCurve, CaseStudiesImageCard, CaseStudyHeading, Section } from '../../utils/CaseStudiesComponents';

// CaseStudy Component
const SingareniCollieries = () => {
  return (
    <div className="flex justify-center px-5 md:px-10 lg:px-16  items-center gap-6 text-white pb-16 relative">
      <BackgroundWithCurve />
      <div className="max-w-[1200px] w-full  pt-24 md:pt-32 relative z-10">
        {/* Breadcrumb Navigation */}
        <Brodcrumb
          data={{
            name: 'Singareni Collieries',
            item: [
              { name: 'Industry Use Cases', path: '/all-industries' },
              {
                name: 'Automotive & Transportation',
                path: '/industries/automotive-transportation',
              },
            ],
          }}
        />

        <div className="my-10 flex flex-col w-full gap-10">
          {/* Header Section with Logo */}
          <div className="flex gap-3 md:gap-5 lg:gap-10">
            <div className="h-[108px] w-[108px]   flex justify-center items-center shadow-md">
              {/* Company Logo */}
              {imagePath?.SingareniLogo ? (
                <img src={imagePath?.SingareniLogo} alt="Medha Logo" />
              ) : (
                <span className="text-gray-400">No Logo</span>
              )}
            </div>

            {/* Case Study Heading */}
            <div className="flex flex-col gap-2 md:gap-5 justify-center">
              <CaseStudyHeading
                title="Singareni Collieries"
                desc="Multi-player VR based instructional experience"
              />
            </div>
          </div>

          <div className="relative">
            {/* Video Container - Responsive aspect ratio */}
            <div className="relative w-full aspect-video bg-[#31333A] shadow-[0px_0px_21px_4px_rgba(0,0,0,0.25)] flex justify-center items-center ">
              {/* Play Icon */}
              {videoPath?.SingareniVideo && (
                <video
                  src={videoPath?.SingareniVideo}
                  autoPlay
                  muted
                  loop
                  playsInline
                  className="w-full h-full object-cover rounded-lg"
                >
                  Your browser does not support the video tag.
                </video>
              )}

              {/* {iconsPath?.QRIcon && (
                <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 lg:-top-8 lg:-right-8 bg-[#fff] p-2 md:p-3 rounded-[10px]">
                  <img
                    src={iconsPath.QRIcon}
                    alt="QR Code"
                    className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24"
                  />
                </div>
              )} */}
            </div>
          </div>

          {/* Case Study Description */}
          <Section
            title="Overview"
            subtitle="Improving knowledge and retention rates of miners on the job."
            content="One of the challenges this leading organization is to assess and evaluate the attention span and
            engagement through an instructor-led walk through of the application for their trainees and
            professionals. The program was designed to provide an immersive experience to their
            participants on the different tools and applications of the same."
          />

          <Section
            title="Execution"
            content={[
              'For Singareni Collieries, Spatial Grid developed a comprehensive VR training solution tailored forboth underground and opencast mining operations. The program comprised 10 structured courses aligned with 10 critical Standard Operating Procedures (SOPs), each supported by carefully designedstoryboards to ensure intuitive understanding for operators, with flexibility to support local languages',
              'Real-world mine environments were recreated by generating 3D models from video references, delivering a highly realistic training context. The experience was further enhanced with detailed simulations and animations, optimized for deployment on VR devices. To ensure controlled usage, thesolution incorporated geofencing so the training operated only within prescribed areas, along with a multi-player capability that enabled instructors to monitor, assess, and evaluate participant engagement in real time.',
              'Further discussions regarding creation of additional content and experiences are in progresswith the customer.',
            ]}
          />

          {/* Image Grid Section */}
          <div className="flex flex-col gap-3">
            <div className="flex md:flex-row flex-col gap-10 md:gap-20 w-full">
              <CaseStudiesImageCard
                image={imagePath?.Singareni1}
                title="VR Experience Interface"
              />
              <CaseStudiesImageCard
                image={imagePath?.Singareni2}
                title="Mining Safety VR Training"
              />
            </div>
          </div>

          {/* Impact Section */}
          <div className="flex flex-col gap-3">
            <Section
              title="Impact"
              subtitle="Marked improvement in module based concepts"
              content="Observations and reports related to the training and learning efficiency was quantified which helped
              refine instruction material. The organization is planning to use the data gathered to understand parts
              of the training that wis weak and work towards strengthen for better engagement with the participants."
            />
          </div>
        </div>
      </div>
    </div>
  );
};
<CaseStudyHeading />;
<CaseStudiesImageCard />;

export default SingareniCollieries;